import script from "./WikiGuides.vue?vue&type=script&setup=true&lang=js"
export * from "./WikiGuides.vue?vue&type=script&setup=true&lang=js"

import "./WikiGuides.vue?vue&type=style&index=0&id=94941116&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94941116"]])

export default __exports__